import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';
import DesignCard from './DesignCard';
import rest from '../img/rest.png';
import RESTIcon from '@material-ui/icons/LaunchTwoTone';


export default memo(({ data }) => {


  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', padding:'5px', borderRadius:'25px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'
}
    
    return (
    <div className="designnode">
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img draggable={false} src={rest} width='50' height='50'></img> */}
      <RESTIcon fontSize='large' style={designerIconStyle} draggable={false}/>

      {/* <Handle
        type="source"
        position="left"
        id="r1"
        style={{ bottom: '10%', top: 'auto', background: '#555' }}
      /> */}
      <DesignCard attributes={data.attributes} name={data.label}/>

      {/* <Handle
        type="source"
        position="right"
        id="r2"
        style={{ bottom: '10%', top: 'auto', background: '#555' }}
      /> */}

      <Handle
        type="source"
        position="bottom"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />


    </div>
  );
});